import * as ActionTypes from './action-types.constants';

export const init = (seriesPath="/",episodes = [], ifiPath = "/ifi-1") => {
    return {
        type: ActionTypes.INIT,
        seriesPath,
        episodes,
        ifiPath
    }
}

export const addIFI = (config) => {
	return {
		type: ActionTypes.ADD_IFI,
		config
	}
}